/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Prefer_CallInputs */

const en_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to call?`)
};

const es_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Prefieres llamar?`)
};

const de_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie lieber anrufen?`)
};

const zh_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想要打电话吗？`)
};

const ar_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفضّل الاتصال؟`)
};

const fr_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous préférez appeler ?`)
};

const vi_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thích gọi điện hơn?`)
};

const sw_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je, unapendelea kupiga simu?`)
};

const th_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้องการโทรไหม?`)
};

const bs_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radije biste nazvali?`)
};

const ja_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お電話でのお問い合わせ`)
};

const ko_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전화 예약을 원하시나요?`)
};

const pt_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefere ligar?`)
};

const it_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisci chiamare?`)
};

const sv_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vill du hellre ringa?`)
};

const nl_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bel je liever?`)
};

const da_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretrækker du at ringe?`)
};

const nb_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foretrekker du å ringe?`)
};

const fi_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soitatko mieluummin?`)
};

const pl_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolisz zadzwonić?`)
};

const ru_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпочитаете звонить?`)
};

const tr_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonla mı ulaşmak istersiniz?`)
};

const hi_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉल करना पसंद करेंगे?`)
};

const id_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih suka menelepon?`)
};

const ms_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebih suka menelefon?`)
};

const cs_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raději zavoláte?`)
};

const el_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προτιμάτε να τηλεφωνήσετε;`)
};

const he_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעדיפים להתקשר?`)
};

const af_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkies jy om te bel?`)
};

const hu_booking_prefer_call = /** @type {(inputs: Booking_Prefer_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkább felhívsz?`)
};

/**
* | output |
* | --- |
* | "Prefer to call?" |
*
* @param {Booking_Prefer_CallInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_prefer_call = /** @type {((inputs?: Booking_Prefer_CallInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Prefer_CallInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_prefer_call(inputs)
	if (locale === "de") return de_booking_prefer_call(inputs)
	if (locale === "zh") return zh_booking_prefer_call(inputs)
	if (locale === "ar") return ar_booking_prefer_call(inputs)
	if (locale === "fr") return fr_booking_prefer_call(inputs)
	if (locale === "vi") return vi_booking_prefer_call(inputs)
	if (locale === "sw") return sw_booking_prefer_call(inputs)
	if (locale === "th") return th_booking_prefer_call(inputs)
	if (locale === "bs") return bs_booking_prefer_call(inputs)
	if (locale === "ja") return ja_booking_prefer_call(inputs)
	if (locale === "ko") return ko_booking_prefer_call(inputs)
	if (locale === "pt") return pt_booking_prefer_call(inputs)
	if (locale === "it") return it_booking_prefer_call(inputs)
	if (locale === "sv") return sv_booking_prefer_call(inputs)
	if (locale === "nl") return nl_booking_prefer_call(inputs)
	if (locale === "da") return da_booking_prefer_call(inputs)
	if (locale === "nb") return nb_booking_prefer_call(inputs)
	if (locale === "fi") return fi_booking_prefer_call(inputs)
	if (locale === "pl") return pl_booking_prefer_call(inputs)
	if (locale === "ru") return ru_booking_prefer_call(inputs)
	if (locale === "tr") return tr_booking_prefer_call(inputs)
	if (locale === "hi") return hi_booking_prefer_call(inputs)
	if (locale === "id") return id_booking_prefer_call(inputs)
	if (locale === "ms") return ms_booking_prefer_call(inputs)
	if (locale === "cs") return cs_booking_prefer_call(inputs)
	if (locale === "el") return el_booking_prefer_call(inputs)
	if (locale === "he") return he_booking_prefer_call(inputs)
	if (locale === "af") return af_booking_prefer_call(inputs)
	if (locale === "hu") return hu_booking_prefer_call(inputs)
	return en_booking_prefer_call(inputs)
});